let resizeHandler

class WindowEvents {
  constructor () {
    this.debounceDelay = 300
    this.resizeHandlers = []
    this.resizeDebounce = null
  }

  resize () {
    clearTimeout(this.resizeDebounce)
    this.resizeDebounce = setTimeout(() => {
      for (const handler of this.resizeHandlers) handler.fn(window.innerWidth, window.innerHeight)
    }, this.debounceDelay)
  }
}

const windowEvents = new WindowEvents()

export function enableWindowEvents () {
  if (resizeHandler) window.removeEventListener('resize', resizeHandler)
  window.addEventListener('resize', resizeHandler = windowEvents.resize.bind(windowEvents))
  resizeHandler()
}

export function useResize (handler) {
  windowEvents.resizeHandlers.push({
    fn: handler
  })
  handler()
}
